(function () {
  // LE MOTEUR DES CARROUSELS MOONBUNDLE, chargé par snippets/tm-arguments-achat.liquid sur toutes
  // les fiches (2026-10-21). Chaque offre ne porte plus que ses réglages, window.__tmMbR, écrits
  // par catalogue/sides-2026-10-18/moonbundle/generer.py : une correction se fait ici, en un seul
  // envoi, au lieu d'un script de 40 Ko recopié dans chaque offre.
  // ⚠️ Une offre encore à l'ancien script complet (il pose window.__tmMbSides) garde le sien : le
  // moteur reste alors inerte, sans quoi chaque clic sur une carte serait compté deux fois.
  if (window.__tmMbMoteur) return;
  window.__tmMbMoteur = true;

  // les réglages de l'offre de la page (familles : collections réelles du catalogue, comptées
  // sur la page ; preferes : UN seul, deux « préférés » se contrediraient)
  var R = null;
  function reglages() {
    R = window.__tmMbSides ? null : (window.__tmMbR || null);
    return R;
  }

  var svg = function (d) {
    return '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };

  // ce que Moonbundle pose sur la page (l'offre et ses produits), rangé par lubrifiant
  function donnees(comp) {
    if (!comp) return {};
    if (comp.__tmDonnees) return comp.__tmDonnees;
    var par = {};
    try {
      var cfg = JSON.parse(comp.getAttribute('bundle') || '{}');
      var autres = JSON.parse(comp.getAttribute('other-products') || '[]');
      var parHandle = {};
      // selon la fiche, Moonbundle pose des objets ou des objets écrits en texte JSON (fiches de jeux)
      autres.forEach(function (p) {
        if (typeof p === 'string') { try { p = JSON.parse(p); } catch (e) { return; } }
        if (p && p.handle) parHandle[p.handle] = p;
      });
      (cfg.configs || []).forEach(function (c) {
        (c.upsells || []).forEach(function (u) {
          var h = u.products && u.products[0] && u.products[0].handle;
          var p = h ? parHandle[h] : null;
          par[u.id] = {
            handle: h,
            collections: p ? (p.collections || []).map(function (x) { return x.handle; }) : [],
            // aucune variante en vente : épuisé, même sans sélecteur (produit à une variante)
            dispo: !p || !p.variants || !p.variants.length || p.variants.some(function (v) { return v.available !== false; })
          };
        });
      });
    } catch (e) {}
    comp.__tmDonnees = par;
    return par;
  }
  // un lubrifiant dont la contenance ou le parfum choisi est en rupture ne se choisit pas
  function epuise(carte) {
    return !!(carte && carte.querySelector('.moonbundle-variant-error-message, .moonbundle-variant-select-invalid'));
  }
  // le sextoy de la fiche est-il achetable ? Lu sur le bouton d'ajout du thème
  // (désactivé = épuisé). null quand la page n'a pas ce bouton
  function sextoyDispo() {
    var b = document.querySelector('form[id^="product-form-template"] [name="add"]') || document.querySelector('product-form form [name="add"]');
    return b ? !b.disabled : null;
  }
  // un produit à une seule variante n'a pas de sélecteur, donc Moonbundle n'écrit pas
  // « épuisé » : on pose le même message, et tout le reste (photo pâlie, bout de
  // carrousel, « + » bloqué) suit comme pour les autres. Trouvé sur le masque, 2026-10-19
  function marquerEpuises(c) {
    c.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var i = info(it);
      if (!i || i.dispo || epuise(it)) return;
      var m = document.createElement('p');
      m.className = 'moonbundle-variant-error-message tm-mb-epuise';
      m.textContent = 'Épuisé pour le moment';
      (it.querySelector('.moonbundle-upsell-item-main') || it).appendChild(m);
      var coche = it.querySelector('.moonbundle-upsell-checkbox input:checked');
      if (coche) coche.click();
    });
  }
  // une carte limitée à certaines valeurs de variante (R.variantes : handle -> valeurs gardées ;
  // le Sexmatch n'est proposé qu'en édition Massage sur une fiche massage, 2026-10-20).
  // Moonbundle ne sait pas restreindre une carte, mais il lit son <select> : on y retire les
  // autres valeurs (essayé au panier sur les menottes : la valeur laissée part bien au panier)
  function variantes(c) {
    if (!R.variantes) return;
    c.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var i = info(it);
      var garde = i && R.variantes[i.handle];
      if (!garde) return;
      it.querySelectorAll('select').forEach(function (s) {
        var change = false;
        Array.prototype.slice.call(s.options).forEach(function (o) {
          if (garde.indexOf(o.text.trim()) < 0) { o.remove(); change = true; }
        });
        if (change) s.dispatchEvent(new Event('change', { bubbles: true }));
        // une seule valeur : le choix n'a plus lieu d'être, le titre de la carte la nomme
        var bloc = s.closest('.moonbundle-variant-select');
        if (bloc && s.options.length <= 1 && bloc.style.display !== 'none') bloc.style.display = 'none';
      });
    });
  }
  function info(carte) {
    if (!carte) return null;
    return donnees(carte.closest('moonbundle-component'))[carte.getAttribute('data-upsell-id')] || null;
  }
  function adresse(carte) {
    var i = info(carte);
    if (!i || !i.handle) return null;
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return racine + 'products/' + i.handle;
  }

  // une famille : [clé, nom] = une collection du catalogue ; [clé, nom, fiches, préféré]
  // = une liste de handles (offres par édition, Sexmatch)
  function famille(cle) {
    var f = null;
    R.familles.forEach(function (x) { if (x[0] === cle) f = x; });
    return f;
  }
  // la fiche ouverte, lue dans l'adresse (/products/<handle>)
  function ficheHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  // une carte réservée à certaines fiches (R.seulementSur : handle de la carte -> fiches où elle
  // se montre ; Mission 69 sur les seuls produits de massage comestibles, 2026-10-20)
  function horsFiche(i) {
    var l = i && R.seulementSur && R.seulementSur[i.handle];
    return !!(l && l.indexOf(ficheHandle()) < 0);
  }
  function dansFamille(i, cle) {
    if (i && horsFiche(i)) return false;
    if (!cle) return true;
    if (!i) return false;
    var f = famille(cle);
    return f && f[2] ? f[2].indexOf(i.handle) >= 0 : i.collections.indexOf(cle) >= 0;
  }
  // l'édition choisie sur la fiche du jeu décide de la famille montrée (R.parVariante :
  // identifiant de variante -> clé de famille). null quand l'offre n'en dépend pas
  function familleFiche() {
    if (!R.parVariante) return null;
    var v = document.querySelector('form[id^="product-form-template"] input[name="id"]') || document.querySelector('product-form form input[name="id"]');
    return v ? (R.parVariante[v.value] || '') : '';
  }
  // le produit de la fiche (offre massage, 2026-10-20) : son type donne le mot (« cette huile »),
  // la variante choisie donne le prix
  function produitPage() {
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!m || !m.variants) return null;
    var v = document.querySelector('form[id^="product-form-template"] input[name="id"]') || document.querySelector('product-form form input[name="id"]');
    var id = v ? Number(v.value) : null;
    var vv = m.variants.filter(function (x) { return x.id === id; })[0] || m.variants[0];
    return { type: m.type, prix: vv ? vv.price : null, nom: vv ? vv.name : '', variante: vv ? vv.public_title : '', variantes: m.variants };
  }
  function motProduit() {
    var p = produitPage();
    var n = p && R.produits && R.produits[p.type];
    return n ? n[0] : 'produit';
  }
  function nomProduit() {
    var p = produitPage();
    var n = p && R.produits && R.produits[p.type];
    return n ? n[1] + ' ' + n[0] : 'ce produit';
  }
  // le prix du produit de la fiche une fois la remise « avec un jeu » appliquée, calculé
  // comme la remise automatique de Shopify, qui TRONQUE au centime (panier du 2026-10-20 :
  // 22,95 € -> -6,88 €, 22,99 € -> -6,89 €). Moonbundle, lui, arrondit au plus proche.
  function prixEffet() {
    var p = produitPage();
    if (!R.effet || !p || p.prix == null) return null;
    var d = Math.floor(p.prix * R.effet.pourcent / 100);
    return { prix: enEuros((p.prix - d) / 100), avant: enEuros(p.prix / 100) };
  }
  // une famille qui ne remise pas ses produits mais le produit de la fiche (les jeux sur une
  // fiche massage) : chaque carte le dit, « Votre huile à -30 % »
  function effets(c) {
    if (!R.effet) return;
    var texte = R.effet.pastille.replace('{mot}', motProduit());
    c.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var dans = dansEffet(it);
      var p = it.querySelector('.tm-mb-effet');
      if (!dans) { if (p) p.remove(); return; }
      if (!p) {
        p = document.createElement('p');
        p.className = 'tm-mb-effet';
        (it.querySelector('.moonbundle-upsell-item-main') || it).appendChild(p);
      }
      if (p.textContent !== texte) p.textContent = texte;
    });
  }
  // le palier de quantité choisi (offre « 1 produit », « 2 produits », « 3 produits »), lu sur la
  // case cochée et la quantité de l'offre dans la configuration Moonbundle. 1 sans paliers
  function palier(box) {
    var w = box ? box.querySelectorAll('.moonbundle-option-wrapper') : [];
    for (var k = 0; k < w.length; k++) {
      var c = w[k].querySelector('.moonbundle-option-checkbox input');
      if (!c || !c.checked) continue;
      try {
        var comp = box.closest('moonbundle-component') || box;
        var o = JSON.parse(comp.getAttribute('bundle') || '{}').configs[0].offers[k];
        return (o && o.qty) || k + 1;
      } catch (e) { return k + 1; }
    }
    return 1;
  }
  // R.effet.famille '*' : toutes les cartes (les sextoys d'une fiche lubrifiant, 2026-10-20)
  // ⚠️ DÈS 2 PRODUITS, PAS DE PASTILLE « À -30 % » (2026-10-20, revu le 2026-10-21) : notre remise
  // ne prend qu'UNE unité du produit de la fiche, le palier se reporte sur les autres. La pastille
  // ferait croire à -30 % sur toutes ; l'addition, elle, donne le vrai total.
  function dansEffet(it) {
    return eligibleEffet(it) && palier(it.closest('.moonbundle-box')) <= 1;
  }
  // la carte déclenche-t-elle notre remise automatique sur le produit de la fiche (« Avec un jeu »,
  // « Avec un sextoy »...), quel que soit le palier : c'est ce que le panier calcule
  function eligibleEffet(it) {
    if (!R.effet) return false;
    var i = info(it);
    if (!i) return false;
    if (R.effet.famille === '*') return true;
    var f = famille(R.effet.famille);
    return !!(f && f[2] && f[2].indexOf(i.handle) >= 0);
  }

  // une édition peut avoir ses propres filtres, f[4] = [[clé, nom, fiches, préféré], ...]
  // (Sexmatch Bondage : Massage, Accessoires, 2026-10-19). Clé vide = « Tous »
  function sousFamille(cle, sous) {
    var f = famille(cle);
    var l = (f && f[4]) || [];
    for (var k = 0; k < l.length; k++) if (l[k][0] === sous) return l[k];
    return null;
  }

  function etat(c, g, d) {
    g.disabled = c.scrollLeft < 4;
    d.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 4;
  }
  // la barre sous le carrousel : sa part visible et sa position
  function progres(c) {
    var b = c.__tmBarre;
    if (!b) return;
    var max = c.scrollWidth - c.clientWidth;
    var part = c.scrollWidth ? c.clientWidth / c.scrollWidth : 1;
    b.style.display = part >= 0.99 ? 'none' : '';
    var l = Math.max(part * 100, 8);
    b.firstChild.style.width = l + '%';
    b.firstChild.style.left = (max > 0 ? c.scrollLeft / max : 0) * (100 - l) + '%';
  }
  function placer(c, g, d) {
    var t = c.offsetTop + c.offsetHeight / 2 - 18;
    g.style.top = d.style.top = t + 'px';
    etat(c, g, d);
    progres(c);
  }

  // le titre : « -30 % » en framboise, puis une ligne qui dit combien il y en a
  function titre(box, n) {
    var h = box.querySelector('.moonbundle-title');
    if (!h) return;
    // « ce produit » du titre Moonbundle devient le mot de la fiche (« cette huile »)
    if (R.titreProduit) {
      var nom = nomProduit();
      for (var j = 0; j < h.childNodes.length; j++) {
        var tn = h.childNodes[j];
        // une seule fois : « ce produit de bain » contient encore « ce produit », et sans ce garde-fou
        // le titre s'allongeait à chaque passage (« de bain de bain de bain... », 2026-10-21)
        if (tn.nodeType === 3 && nom !== 'ce produit' && tn.nodeValue.indexOf(nom) < 0 && tn.nodeValue.indexOf('ce produit') >= 0) tn.nodeValue = tn.nodeValue.replace('ce produit', nom);
      }
    }
    if (!h.querySelector('.tm-mb-accent')) {
      for (var i = 0; i < h.childNodes.length; i++) {
        var t = h.childNodes[i];
        var k = t.nodeType === 3 ? t.nodeValue.indexOf('-30 %') : -1;
        if (k < 0) continue;
        var reste = t.splitText(k);
        reste.splitText(5);
        var s = document.createElement('span');
        s.className = 'tm-mb-accent';
        reste.parentNode.replaceChild(s, reste);
        s.appendChild(reste);
        break;
      }
    }
    var p = h.nextElementSibling;
    if (!p || !p.classList.contains('tm-mb-sous-titre')) {
      p = document.createElement('p');
      p.className = 'tm-mb-sous-titre';
      h.parentNode.insertBefore(p, h.nextSibling);
    }
    var cle = box.__tmFiltre;
    var f = cle && R.parVariante ? famille(cle) : null;
    var texte = f ? n + R.sousTitreEdition.replace('{nom}', f[1]) : n + R.sousTitre;
    // un sous-titre propre au filtre actif (offre massage : accessoires, puis jeux)
    // ('*' : le même sous-titre pour tous les filtres, « Tous » compris : offre lubrifiants)
    var sf = R.sousTitreFamille ? (cle && R.sousTitreFamille[cle]) || R.sousTitreFamille['*'] || null : null;
    if (sf) {
      var pe = prixEffet();
      var nf = Array.prototype.filter.call(box.querySelectorAll('.moonbundle-upsell-item'), function (it) { return dansFamille(info(it), cle); }).length;
      // un palier de 2 ou 3 choisi : l'effet ne s'affiche plus (voir dansEffet), le sous-titre
      // qui l'annonce non plus
      if (sf.indexOf('{prix}') >= 0 && palier(box) > 1) texte = nf + R.sousTitre;
      else texte = sf.replace('{n}', nf).replace('{produit}', nomProduit()).replace('{prix}', pe ? pe.prix : '').replace('{avant}', pe ? pe.avant : '');
    }
    if (p.textContent !== texte) p.textContent = texte;
  }

  // les filtres par famille, au-dessus du carrousel ; sur une offre par édition, ceux de
  // l'édition choisie, refaits quand elle change
  function filtres(box, c) {
    var cartes = Array.prototype.slice.call(c.querySelectorAll('.moonbundle-upsell-item'));
    if (!cartes.length) return;
    var choix, cle = null;
    if (R.parVariante) {
      cle = box.__tmFiltre || '';
      var avant = box.querySelector('.tm-mb-filtres');
      if (avant && avant.getAttribute('data-edition') === cle) return;
      if (avant) avant.remove();
      box.__tmSous = '';
      var f = famille(cle);
      if (!f || !f[4]) return;
      var dans = cartes.filter(function (it) { return dansFamille(info(it), cle); });
      choix = [['', 'Tous', dans.length]];
      f[4].forEach(function (s) {
        var n = dans.filter(function (it) { var i = info(it); return i && s[2].indexOf(i.handle) >= 0; }).length;
        if (n >= 1) choix.push([s[0], s[1], n]);
      });
    } else {
      if (box.querySelector('.tm-mb-filtres')) return;
      // R.sansTous : pas de « Tous », le premier filtre est choisi d'office (offre massage)
      choix = R.sansTous ? [] : [['', 'Tous', cartes.length]];
      R.familles.forEach(function (f) {
        var n = cartes.filter(function (it) { return dansFamille(info(it), f[0]); }).length;
        if (n >= (R.sansTous ? 1 : 2)) choix.push([f[0], f[1], n]);
      });
      if (R.sansTous && choix.length && !box.__tmFiltre) {
        box.__tmFiltre = choix[0][0];
        box.__tmRemettre = true;
      }
    }
    if (choix.length < (R.sansTous ? 1 : 2)) return;
    var nav = document.createElement('div');
    nav.className = 'tm-mb-filtres';
    if (cle !== null) nav.setAttribute('data-edition', cle);
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', R.filtrer);
    choix.forEach(function (ch) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tm-mb-filtre';
      b.setAttribute('data-famille', ch[0]);
      b.setAttribute('aria-pressed', ch[0] === (R.sansTous ? box.__tmFiltre : '') ? 'true' : 'false');
      b.appendChild(document.createTextNode(ch[1]));
      var n = document.createElement('span');
      n.textContent = ch[2];
      b.appendChild(n);
      nav.appendChild(b);
    });
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.tm-mb-filtre');
      if (!b) return;
      if (R.parVariante) box.__tmSous = b.getAttribute('data-famille');
      else box.__tmFiltre = b.getAttribute('data-famille');
      nav.querySelectorAll('.tm-mb-filtre').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var cc = box.querySelector('.moonbundle-upsells-container');
      if (!cc) return;
      appliquer(cc);
      conseils(cc);
      if (R.sousTitreFamille) titre(box, 0);
      cc.scrollLeft = 0;
      if (cc.__tmFleches) placer(cc, cc.__tmFleches[0], cc.__tmFleches[1]);
    });
    c.parentNode.insertBefore(nav, c);
  }
  function appliquer(c) {
    var box = c.closest('.moonbundle-box');
    var f = (box && box.__tmFiltre) || '';
    var s = R.parVariante && box && box.__tmSous ? sousFamille(f, box.__tmSous) : null;
    var fam = famille(f);
    var liste = s ? s[2] : (fam && fam[2]) || null;
    Array.prototype.forEach.call(c.children, function (w) {
      var it = w.querySelector('.moonbundle-upsell-item');
      var i = info(it);
      var dedans = dansFamille(i, f);
      var garde = dedans && (!s || !!(i && s[2].indexOf(i.handle) >= 0));
      if (w.classList.contains('tm-mb-masque') === !!garde) w.classList.toggle('tm-mb-masque', !garde);
      // une liste de fiches donne l'ordre du carrousel (Bondage : la grosse bougie Shunga
      // d'abord), les épuisés restent au bout comme le fait le customCss
      var rang = liste && i ? liste.indexOf(i.handle) : -1;
      var ordre = rang < 0 ? '' : String((epuise(it) ? 100 : 0) + rang);
      if (w.style.order !== ordre) w.style.order = ordre;
      // l'édition a changé : le produit coché d'une autre édition se décoche (pas pour
      // un simple filtre, qui ne fait que parcourir)
      var coche = !dedans && R.parVariante && w.querySelector('.moonbundle-upsell-checkbox input:checked');
      if (coche) coche.click();
    });
  }

  // « Notre préféré » sur la carte du lubrifiant choisi par la boutique
  function conseils(c) {
    var box = c.closest('.moonbundle-box');
    var f = box && box.__tmFiltre ? famille(box.__tmFiltre) : null;
    var s = f && R.parVariante && box.__tmSous ? sousFamille(f[0], box.__tmSous) : null;
    var pref = s && s[3] ? [s[3]] : f && f[3] ? [f[3]] : R.preferes;
    c.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var i = info(it);
      var badge = it.querySelector('.tm-mb-conseil');
      var oui = !!(i && pref.indexOf(i.handle) >= 0);
      if (badge && !oui) badge.remove();
      if (!oui || badge) return;
      var s = document.createElement('span');
      s.className = 'tm-mb-conseil';
      s.textContent = 'Notre préféré';
      it.appendChild(s);
    });
  }

  // ---- LE RÉCAPITULATIF : L'ADDITION DE CE QUI PART AU PANIER (Julien, 2026-10-21 : « une ligne,
  // comme une addition, pour avoir un récap de ce que l'on a et pour combien ») ----
  // Le produit de la fiche au palier choisi, chaque produit coché, puis le total, repris sur le
  // bouton d'ajout au panier.
  // ⚠️ NOS REMISES SE CUMULENT AVEC CELLES DE MOONBUNDLE DEPUIS LE 2026-10-21 (Julien), UNE PAR
  // ARTICLE : la nôtre (« Avec un jeu », « Avec un sextoy »...) prend UNE unité du produit de la
  // fiche à -30 % (une fois par commande), et Shopify reporte le montant du palier Moonbundle sur
  // les autres unités (3 flacons + un sextoy : 1 à -30 %, les 2 autres à -30 % aussi, paniers du
  // 2026-10-21) ; les cartes gardent leur prix Moonbundle. Donc : prix au palier - notre remise.
  // (Avant le 2026-10-21, le panier prenait SOIT l'une SOIT l'autre : voir la sauvegarde.)
  function euros(t) {
    var n = parseFloat(String(t || '').replace(/[^\d,.]/g, '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
  }
  function enEuros(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  function centimes(t) {
    return Math.round(euros(t) * 100);
  }
  // le prix d'une carte remisée, COMME LE PANIER : Moonbundle affiche le prix final arrondi, mais
  // son panier arrondit la REMISE (32,95 € à -30 % : la carte disait 23,07 €, le panier facture
  // 23,06 €, 2026-10-21). Tous les prix en ,95 étaient faux d'un centime : on réécrit la carte.
  function prixCartes() {
    document.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var p = it.querySelector('.moonbundle-upsell-price');
      var o = it.querySelector('.moonbundle-upsell-original-price');
      if (!p || !o || !o.textContent.trim()) return;
      var avant = centimes(o.textContent), prix = centimes(p.textContent);
      if (!(avant > prix) || !prix) return;
      var pct = Math.round((avant - prix) * 100 / avant);
      var juste = avant - Math.round(avant * pct / 100);
      if (juste !== prix && Math.abs(juste - prix) <= 1) p.textContent = enEuros(juste / 100);
    });
  }
  function quantiteTheme() {
    var q = document.querySelector('form[id^="product-form-template"] input[name="quantity"]') || document.querySelector('quantity-input input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  // le produit de la fiche : son nom sans la phrase du titre (« Coffret de massage comestible
  // Lips »), le palier choisi, ses parfums, son prix au palier et sans remise, le prix de chaque unité
  function lignePrincipale(box) {
    var p = produitPage();
    if (!p || p.prix == null) return null;
    var l = { nom: String(p.nom || '').split(' - ')[0], q: 1, prix: p.prix, avant: p.prix, unites: [p.prix],
      v: p.variante && p.variante !== 'Default Title' ? p.variante : '' };
    var w = box.querySelectorAll('.moonbundle-option-wrapper');
    if (!w.length) {
      // pas de paliers : la quantité est celle du thème
      l.q = quantiteTheme();
      l.prix = l.avant = p.prix * l.q;
      return l;
    }
    for (var k = 0; k < w.length; k++) {
      var c = w[k].querySelector('.moonbundle-option-checkbox input');
      if (!c || !c.checked) continue;
      l.q = palier(box);
      var sp = w[k].querySelector('.moonbundle-option-single-price');
      var op = w[k].querySelector('.moonbundle-option-old-price');
      if (sp) l.prix = centimes(sp.textContent);
      l.avant = op && op.textContent.trim() ? centimes(op.textContent) : l.prix;
      if (l.q > 1) {
        var noms = [], unites = [];
        w[k].querySelectorAll('.moonbundle-variants-box select').forEach(function (s) {
          var t = s.selectedIndex >= 0 ? s.options[s.selectedIndex].text.trim() : '';
          noms.push(t);
          var vv = (p.variantes || []).filter(function (x) { return x.public_title === t; })[0];
          if (vv) unites.push(vv.price);
        });
        // les parfums regroupés : « Fraise », « Fraise ×2, Pomme »
        var compte = {}, ordre = [];
        noms.forEach(function (t) {
          if (!t || t === 'Default Title') return;
          if (!compte[t]) { compte[t] = 0; ordre.push(t); }
          compte[t]++;
        });
        l.v = ordre.length === 1 ? ordre[0] : ordre.map(function (t) { return compte[t] > 1 ? t + ' ×' + compte[t] : t; }).join(', ');
        l.unites = unites.length === l.q ? unites : [Math.round(l.avant / l.q)];
      }
      break;
    }
    return l;
  }
  function boutonTotal(total, montrer) {
    var b = document.querySelector('form[id^="product-form-template"] [name="add"]') || document.querySelector('product-form form [name="add"]');
    if (!b) return;
    var s = b.querySelector('.tm-mb-atc-total');
    var texte = montrer && !b.disabled ? enEuros(total / 100) : '';
    if (!texte) { if (s) s.remove(); return; }
    if (!s) {
      s = document.createElement('span');
      s.className = 'tm-mb-atc-total';
      // DANS le libellé et pas à côté : sur téléphone le total passe sous « Ajouter au panier »,
      // il ne reste que 198 px entre les deux cerises. Dawn réécrit ce libellé au changement de
      // variante, l'observateur le remet
      var t = b.querySelector(':scope > span');
      (t || b).appendChild(s);
    }
    if (s.textContent !== texte) s.textContent = texte;
  }
  function recap(box, c) {
    var r = box.querySelector('.tm-mb-recap');
    if (!r) {
      // un <p> et pas un <div> : Moonbundle force l'affichage de tout div vide (div:empty en !important)
      r = document.createElement('p');
      r.className = 'tm-mb-recap';
      r.setAttribute('aria-live', 'polite');
    }
    // au bas de l'offre, juste au-dessus du bouton : après les paliers s'il y en a, sinon après le carrousel
    var w0 = box.querySelector('.moonbundle-option-wrapper');
    var apres = w0 ? w0.parentElement : c ? (c.__tmBarre || c) : null;
    if (!apres) return;
    if (r.previousElementSibling !== apres) apres.parentNode.insertBefore(r, apres.nextSibling);
    var comp = box.closest('moonbundle-component') || box;
    var main = lignePrincipale(box);
    if (!main || comp.style.display === 'none') { r.hidden = true; r.__tmCle = ''; boutonTotal(0, false); return; }
    var cotes = [];
    if (c) c.querySelectorAll('.moonbundle-upsell-item').forEach(function (it) {
      var i = it.querySelector('.moonbundle-upsell-checkbox input');
      if (!i || !i.checked) return;
      var t = it.querySelector('.moonbundle-upsell-title-text');
      var sel = it.querySelector('select');
      var p = it.querySelector('.moonbundle-upsell-price');
      var o = it.querySelector('.moonbundle-upsell-original-price');
      var prix = p ? centimes(p.textContent) : 0;
      cotes.push({
        coche: i,
        nom: t ? t.textContent.trim() : '',
        v: sel && sel.selectedIndex >= 0 && sel.options.length > 1 ? sel.options[sel.selectedIndex].text.trim() : '',
        prix: prix,
        avant: o && o.textContent.trim() ? centimes(o.textContent) : prix,
        effet: eligibleEffet(it)
      });
    });
    // les remises Moonbundle (palier, cartes) ET la nôtre sur une unité du produit de la fiche
    var sMb = main.avant - main.prix;
    cotes.forEach(function (l) { sMb += l.avant - l.prix; });
    var sJeu = 0;
    if (R.effet && cotes.some(function (l) { return l.effet; })) {
      sJeu = Math.floor(Math.min.apply(null, main.unites) * R.effet.pourcent / 100);
    }
    var lignes = [{ nom: main.nom + (main.q > 1 ? ' × ' + main.q : '') + (sJeu > 0 ? (R.effet.recap || ', avec le jeu') : ''),
      v: main.v, prix: main.prix - sJeu, avant: main.avant }];
    cotes.forEach(function (l) {
      lignes.push({ nom: l.nom, v: l.v, prix: l.prix, avant: l.avant, coche: l.coche });
    });
    var total = 0, totalAvant = 0;
    lignes.forEach(function (l) { total += l.prix; totalAvant += l.avant; });
    var note = sJeu > 0 && sMb > 0;
    boutonTotal(total, true);
    // un seul produit, au prix normal : rien à additionner, le bouton dit déjà le prix
    var montrer = lignes.length > 1 || main.q > 1;
    var cle = montrer + '|' + note + '|' + lignes.map(function (l) { return [l.nom, l.v, l.prix, l.avant].join('|'); }).join('||');
    if (r.__tmCle === cle) return;
    r.__tmCle = cle;
    r.textContent = '';
    // hidden et pas style.display : la règle du récapitulatif est en !important
    if (!montrer) { r.hidden = true; return; }
    r.hidden = false;
    var lib = document.createElement('span');
    lib.className = 'tm-mb-recap-libelle';
    lib.textContent = 'Votre sélection';
    r.appendChild(lib);
    function montant(prix, avant) {
      var m = document.createElement('span');
      m.className = 'tm-mb-recap-montant';
      var pr = document.createElement('span');
      pr.className = 'tm-mb-recap-prix';
      pr.textContent = enEuros(prix / 100);
      m.appendChild(pr);
      if (avant > prix) {
        var s = document.createElement('s');
        s.textContent = enEuros(avant / 100);
        m.appendChild(s);
      }
      return m;
    }
    lignes.forEach(function (l) {
      var ligne = document.createElement('span');
      ligne.className = 'tm-mb-recap-ligne';
      var n = document.createElement('span');
      n.className = 'tm-mb-recap-nom';
      var st = document.createElement('strong');
      st.textContent = l.nom;
      n.appendChild(st);
      if (l.v) {
        var v = document.createElement('span');
        v.className = 'tm-mb-recap-v';
        v.textContent = l.v;
        n.appendChild(v);
      }
      if (l.coche) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = 'Retirer';
        b.addEventListener('click', function () { if (l.coche.checked) l.coche.click(); });
        n.appendChild(b);
      }
      ligne.appendChild(n);
      ligne.appendChild(montant(l.prix, l.avant));
      r.appendChild(ligne);
    });
    var tot = document.createElement('span');
    tot.className = 'tm-mb-recap-total';
    var tl = document.createElement('span');
    tl.textContent = 'Total';
    tot.appendChild(tl);
    tot.appendChild(montant(total, totalAvant));
    r.appendChild(tot);
    if (note) {
      var nt = document.createElement('span');
      nt.className = 'tm-mb-recap-note';
      nt.textContent = 'Une seule remise par article : la plus avantageuse pour vous est appliquée.';
      r.appendChild(nt);
    }
  }

  function monter() {
    if (!reglages()) return;
    styleFenetre();
    prixCartes();
    // une offre sans carrousel (les lubrifiants silicone : les paliers seuls) a quand même son
    // récapitulatif et son total sur le bouton
    document.querySelectorAll('.moonbundle-box').forEach(function (box) {
      if (!box.querySelector('.moonbundle-upsells-container')) recap(box, null);
    });
    document.querySelectorAll('.moonbundle-box .moonbundle-upsells-container').forEach(function (c) {
      var box = c.closest('.moonbundle-box');
      // un sextoy épuisé ne s'achète pas : « avec ce sextoy, -30 % » serait une
      // promesse impossible, l'offre se cache (et revient sur un coloris disponible)
      var comp = c.closest('moonbundle-component') || box;
      var dispo = sextoyDispo();
      var fiche = familleFiche();
      var neuve = fiche !== null && box.__tmFiltre !== fiche;
      if (neuve) box.__tmFiltre = fiche;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      marquerEpuises(c);
      variantes(c);
      filtres(box, c);
      appliquer(c);
      // APRÈS le tri : l'accroche du défilement garde sinon la carte qui était première
      // dans la page (la Bruma, au milieu de l'édition Bondage, 2026-10-19)
      if (neuve || box.__tmRemettre) { c.scrollLeft = 0; box.__tmRemettre = false; }
      // compté sur l'édition entière, pas sur le sous-filtre qu'on parcourt
      var cartes = c.querySelectorAll('.moonbundle-upsell-item');
      var edition = fiche === null ? cartes.length : Array.prototype.filter.call(cartes, function (it) { return dansFamille(info(it), fiche); }).length;
      var montrer = dispo !== false && (fiche === null || edition > 0);
      if ((comp.style.display === 'none') === montrer) comp.style.display = montrer ? '' : 'none';
      titre(box, edition);
      conseils(c);
      effets(c);
      if (!c.__tmBarre || !c.__tmBarre.isConnected) {
        var barre = document.createElement('div');
        barre.className = 'tm-mb-barre';
        barre.setAttribute('aria-hidden', 'true');
        barre.appendChild(document.createElement('span'));
        c.parentNode.insertBefore(barre, c.nextSibling);
        c.__tmBarre = barre;
      }
      recap(box, c);
      if (c.__tmFleches) { placer(c, c.__tmFleches[0], c.__tmFleches[1]); return; }
      box.querySelectorAll('.tm-mb-fleche').forEach(function (x) { x.remove(); });
      var g = document.createElement('button');
      var d = document.createElement('button');
      g.type = d.type = 'button';
      g.className = 'tm-mb-fleche tm-mb-fleche--g';
      d.className = 'tm-mb-fleche tm-mb-fleche--d';
      g.setAttribute('aria-label', R.precedents);
      d.setAttribute('aria-label', R.suivants);
      g.innerHTML = svg('M10 3 5 8l5 5');
      d.innerHTML = svg('m6 3 5 5-5 5');
      box.appendChild(g);
      box.appendChild(d);
      c.__tmFleches = [g, d];
      g.addEventListener('click', function () { c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' }); });
      d.addEventListener('click', function () { c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' }); });
      c.addEventListener('scroll', function () { etat(c, g, d); progres(c); }, { passive: true });
      placer(c, g, d);
    });
  }

  // toute la carte coche le lubrifiant, sauf le choix du parfum ou de la contenance
  document.addEventListener('click', function (e) {
    if (!reglages()) return;
    var carte = e.target.closest && e.target.closest('.moonbundle-box .moonbundle-upsell-item');
    if (!carte) return;
    // la pastille « Détails » est dessinée autour de la photo : elle l'ouvre aussi
    var cadre = e.target.closest('.moonbundle-upsell-image-container');
    if (cadre && !e.target.closest('img')) {
      var photo = cadre.querySelector('img');
      if (photo) photo.click();
      return;
    }
    // la photo et le nom ouvrent la fenêtre du produit, ils ne cochent pas
    if (e.target.closest('input, select, label, button, .moonbundle-upsell-variant-selector-offer, .moonbundle-upsell-image-container, .moonbundle-upsell-title')) return;
    if (epuise(carte)) return;
    var box = carte.querySelector('.moonbundle-upsell-checkbox input');
    if (box) box.click();
  });
  // un épuisé ne se coche pas, même par le bouton « + » : le clic est arrêté avant Moonbundle
  // (en phase de capture, la case porte déjà son nouvel état : checked = on essaie de cocher)
  document.addEventListener('click', function (e) {
    if (!reglages()) return;
    var b = e.target.closest && e.target.closest('.moonbundle-box .moonbundle-upsell-checkbox input');
    if (b && b.checked && epuise(b.closest('.moonbundle-upsell-item'))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  // sans R.plusieurs, UN produit à la fois : en cocher un décoche les autres ; le récapitulatif suit
  document.addEventListener('change', function (e) {
    if (!reglages()) return;
    var b = e.target;
    var box = b.closest && b.closest('.moonbundle-box');
    if (!box) return;
    // une contenance ou un parfum épuisé choisi sur un lubrifiant coché le décoche
    if (b.tagName === 'SELECT') {
      var it = b.closest('.moonbundle-upsell-item');
      setTimeout(function () {
        var i = it && it.querySelector('.moonbundle-upsell-checkbox input');
        if (i && i.checked && epuise(it)) i.click();
      }, 60);
    }
    if (!R.plusieurs && b.matches('.moonbundle-upsell-checkbox input') && b.checked) {
      box.querySelectorAll('.moonbundle-upsell-checkbox input:checked').forEach(function (x) {
        if (x !== b) x.click();
      });
    }
    setTimeout(function () {
      recap(box, box.querySelector('.moonbundle-upsells-container'));
    }, 50);
  });

  // la fenêtre produit de Moonbundle est posée sur <body>, hors de portée du customCss : son style est injecté ici
  var CSS_FENETRE = [
    '.moonbundle-product-info-lightbox-overlay{background:rgba(5,82,33,.45)!important}',
    '.moonbundle-product-info-lightbox-panel{background:#EFEFE1!important;border-radius:22px!important;box-shadow:none!important;max-width:440px!important;width:calc(100% - 32px)!important;max-height:calc(100% - 48px)!important;display:flex!important;flex-direction:column!important;overflow:hidden!important}',
    // ⚠️ LA BARRE BRANDYE SE CACHE PENDANT QUE LA FENÊTRE « DÉTAILS » EST OUVERTE (2026-10-22, Julien :
    // « sur le téléphone on ne peut pas cliquer sur le bouton caché sous la barre d'IA »). Le
    // widget (`brandye-chat-widget`, racine fantôme) est fixé en bas avec un z-index de 2 147 482 500 :
    // il passe au-dessus du voile de Moonbundle et couvrait « Choisir ce produit ». Le panneau
    // n'existe dans la page QUE pendant qu'il est ouvert (ajouté puis retiré du body) : la barre
    // revient seule à la fermeture. Et la barre d'accueil de l'iPhone est réservée en bas.
    'body:has(> .moonbundle-product-info-lightbox-overlay) brandye-chat-widget{display:none!important}',
    '.moonbundle-product-info-lightbox-panel{margin-bottom:env(safe-area-inset-bottom,0px)!important}',
    '.moonbundle-product-info-lightbox-header{border:0!important;padding:18px 18px 8px 22px!important;background:transparent!important;gap:12px}',
    '.moonbundle-product-info-lightbox-header-spacer{display:none!important}',
    '.moonbundle-product-info-lightbox-header-title{text-align:left!important;font-family:"TM Titre","Baloo 2",ui-rounded,"Trebuchet MS",sans-serif!important;font-size:26px!important;font-weight:700!important;line-height:1.1!important;color:#055221!important}',
    '.moonbundle-product-info-lightbox-close{width:36px!important;height:36px!important;flex:0 0 36px!important;border-radius:50%!important;border:0!important;background:#E4E4D2!important;color:#055221!important;font-size:22px!important;line-height:1!important;padding:0!important;cursor:pointer}',
    '.moonbundle-product-info-lightbox-close:hover,.moonbundle-product-info-lightbox-close:focus-visible{background:#D7106C!important;color:#fff!important}',
    '.moonbundle-product-info-lightbox-scroll{padding:4px 22px 4px!important;overflow-y:auto!important}',
    '.moonbundle-pip-gallery{width:min(100%,300px,34vh)!important;margin:0 auto!important;background:#E4E4D2!important;border-radius:16px!important;overflow:hidden!important}',
    '.moonbundle-pip-gallery *{background-color:transparent!important}',
    '.moonbundle-pip-gallery-main-img{object-fit:contain!important;mix-blend-mode:multiply!important}',
    '.tm-mb-cache{display:none!important}',
    '.tm-mb-points{list-style:none;margin:16px 0 6px;padding:0;display:grid;gap:10px}',
    '.tm-mb-points li{position:relative;padding-left:30px;font-size:15px;line-height:1.35;color:#055221}',
    '.tm-mb-points li::before{content:"";position:absolute;left:0;top:0;width:20px;height:20px;border-radius:50%;background:#D7106C url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'%3E%3Cpath d=\'m3.5 8.5 3 3 6-7\' fill=\'none\' stroke=\'%23fff\' stroke-width=\'2.4\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/11px no-repeat}',
    '.tm-mb-choisir{flex:0 0 auto;margin:10px 22px 20px;min-height:50px;border:0;border-radius:999px;background:#D7106C;color:#fff;font-family:"TM Titre","Baloo 2",ui-rounded,"Trebuchet MS",sans-serif!important;font-size:21px!important;font-weight:700!important;cursor:pointer;transition:transform .15s ease}',
    '.tm-mb-choisir:hover,.tm-mb-choisir:focus-visible{transform:translateY(-2px)}',
    '.tm-mb-choisir:disabled{opacity:.45;cursor:not-allowed;transform:none}',
    '.tm-mb-fiche{display:inline-flex;align-items:center;gap:6px;margin:6px 0 2px;color:#D7106C!important;font-size:14px;font-weight:700;text-decoration:underline;text-underline-offset:3px}',
    '.tm-mb-fiche::after{content:"";width:11px;height:11px;background:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 12 12\'%3E%3Cpath d=\'M4.5 2.5h5v5M9.5 2.5l-7 7\' fill=\'none\' stroke=\'%23D7106C\' stroke-width=\'1.8\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/contain no-repeat}',
    '.tm-mb-fiche:hover,.tm-mb-fiche:focus-visible{text-decoration-thickness:2px}',
    '@media (prefers-reduced-motion:reduce){.tm-mb-choisir{transition:none}}',
    '.moonbundle-upsell-item .tm-mb-effet{grid-column:2;justify-self:start;margin:2px 0 0;padding:2px 8px;border-radius:999px;background:#fff;border:1px solid #D8D8C4;color:#055221;font-size:11px;font-weight:700;line-height:15px}',
    // les paliers de quantité (2026-10-20, Julien : -10 % par 2, -20 % par 3), sous le carrousel :
    // tuile comme les cartes, choisie en framboise comme elles, TM Titre à 22 px (police à 75 %).
    // Le palier « 1 produit » suit les pastilles de la fiche (vérifié) : son menu ferait doublon
    '.tm-mb-paliers-titre{margin:22px 0 10px!important;font-family:"TM Titre","Baloo 2",ui-rounded,"Trebuchet MS",sans-serif!important;font-size:23px!important;font-weight:700!important;line-height:1.15!important;color:#055221!important}',
    '.moonbundle-option-wrapper{margin:0 0 8px!important}',
    '.moonbundle-option{background:#E4E4D2!important;border:2px solid transparent!important;border-radius:20px!important;box-shadow:none!important;cursor:pointer;transition:border-color .15s ease,background-color .15s ease}',
    '.moonbundle-option:has(.moonbundle-option-checkbox input:checked){background:#fff!important;border-color:#D7106C!important}',
    '.moonbundle-option-checkbox input{accent-color:#D7106C!important;width:18px!important;height:18px!important}',
    '.moonbundle-option-title,.moonbundle-option-title span{color:#055221!important;font-family:"TM Titre","Baloo 2",ui-rounded,"Trebuchet MS",sans-serif!important;font-size:22px!important;font-weight:700!important;line-height:1.1!important}',
    '.moonbundle-option-subtitle{color:#D7106C!important;font-style:normal!important;font-weight:700!important;font-size:13px!important}',
    '.moonbundle-option-wrapper:first-child .moonbundle-option-subtitle{color:#4A6B55!important;font-weight:400!important}',
    '.moonbundle-option-single-price{color:#055221!important;font-weight:800!important;font-size:18px!important}',
    '.moonbundle-option-old-price{color:#4A6B55!important;font-style:normal!important}',
    '.moonbundle-option-wrapper:first-child .moonbundle-variants-box{display:none!important}',
    '.moonbundle-variants-box,.moonbundle-variants-box *{color:#4A6B55}',
    '.moonbundle-variants-box select{border:1px solid #D8D8C4!important;border-radius:999px!important;background-color:#fff!important;color:#055221!important;padding:4px 28px 4px 12px!important}',
    // DES CARTES ENTIÈRES (2026-10-21, Julien : « sur le upsell ça coupe, je voudrais que ça prenne la
    // pleine largeur ») : la carte suit la largeur du carrousel au lieu des 248 px des offres, 2 par vue
    // dès que le carrousel fait 480 px, 1 en dessous. Les offres écrivent `[data-instance] .moonbundle-
    // upsells-container>div` (0,2,1) en !important : `html body .moonbundle-box ...` (0,2,3) passe devant.
    // Le défilement s'arrête au début d'une carte, et les flèches avancent de 80 % : une page par clic.
    'html body .moonbundle-box .moonbundle-upsells-container{container-type:inline-size}',
    // ⚠️ SUR TÉLÉPHONE, LA CARTE SUIVANTE DÉPASSE (Julien, le lendemain : « qu'on capte qu'il faut scroll,
    // le voir un peu ») : 86 % de large, ~40 px de la suivante visibles sur un carrousel de 358 px. Un
    // écran tactile plus large (pas de flèches, hover:none) garde 2 cartes et un bord de la 3e.
    'html body .moonbundle-box .moonbundle-upsells-container>div{flex:0 0 86%!important;max-width:86%!important}',
    '@container (min-width:480px){html body .moonbundle-box .moonbundle-upsells-container>div{flex-basis:calc(50% - 5px)!important;max-width:calc(50% - 5px)!important}}',
    '@media (hover:none){@container (min-width:480px){html body .moonbundle-box .moonbundle-upsells-container>div{flex-basis:calc(45% - 5px)!important;max-width:calc(45% - 5px)!important}}}',
    // les flèches sortent de 30 px au lieu de 14 : sinon celle de droite couvre le « + » de la 2e carte
    // (mesuré le 2026-10-21). Sur mobile elles sont masquées (hover:none).
    'html body .moonbundle-box .tm-mb-fleche--g{left:-30px!important}',
    'html body .moonbundle-box .tm-mb-fleche--d{right:-30px!important}',
    // le récapitulatif en addition (2026-10-21) : une ligne par produit, le montant à droite, le total
    '.moonbundle-box .tm-mb-recap[hidden]{display:none!important}',
    '.moonbundle-box .tm-mb-recap{display:block!important;margin:14px 0 4px!important;padding:12px 16px!important;border-radius:20px!important;background:#fff!important;border:1px solid #D8D8C4!important;color:#055221!important}',
    '.moonbundle-box .tm-mb-recap-libelle{display:block!important;margin:0 0 4px!important;font-size:11px!important;font-weight:700!important;letter-spacing:.06em!important;text-transform:uppercase!important;color:#4A6B55!important}',
    '.moonbundle-box .tm-mb-recap-ligne{display:grid!important;grid-template-columns:minmax(0,1fr) auto;column-gap:12px;align-items:start;margin:0!important;padding:7px 0!important;border-top:1px solid #E4E4D2}',
    '.moonbundle-box .tm-mb-recap-libelle+.tm-mb-recap-ligne{border-top:0}',
    '.moonbundle-box .tm-mb-recap-nom{display:flex;flex-wrap:wrap;align-items:baseline;gap:2px 8px;font-size:14px;line-height:1.3}',
    '.moonbundle-box .tm-mb-recap-nom strong{font-weight:700}',
    '.moonbundle-box .tm-mb-recap-v{color:#4A6B55;font-size:13px}',
    '.moonbundle-box .tm-mb-recap-nom button{margin:0!important;min-height:24px;padding:0!important;border:0!important;background:none!important;color:#055221!important;font-size:13px!important;font-weight:700!important;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.moonbundle-box .tm-mb-recap-montant{display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;white-space:nowrap}',
    '.moonbundle-box .tm-mb-recap-montant s{order:2;color:#4A6B55!important;font-size:12px!important}',
    '.moonbundle-box .tm-mb-recap-montant .tm-mb-recap-prix{color:#055221!important;font-weight:800!important;font-size:15px!important}',
    '.moonbundle-box .tm-mb-recap-total{display:grid!important;grid-template-columns:minmax(0,1fr) auto;column-gap:12px;align-items:baseline;margin:2px 0 0!important;padding:10px 0 0!important;border-top:2px solid #055221!important;font-size:16px!important;font-weight:800!important;text-align:left!important}',
    '.moonbundle-box .tm-mb-recap-total .tm-mb-recap-prix{color:#D7106C!important;font-size:20px!important}',
    '.moonbundle-box .tm-mb-recap-note{display:block;margin:8px 0 0;font-size:12px;line-height:1.35;color:#4A6B55}',
    '.tm-mb-atc-total{margin-left:.3em;white-space:nowrap}',
    '.tm-mb-atc-total::before{content:"· "}',
    '@media (max-width:749px){.tm-mb-atc-total{display:block;margin:2px 0 0;font-size:15px;line-height:1.1}.tm-mb-atc-total::before{content:none}}'
  ].join('\n');
  function styleFenetre() {
    if (document.getElementById('tm-mb-moteur-style')) return;
    var st = document.createElement('style');
    st.id = 'tm-mb-moteur-style';
    st.textContent = CSS_FENETRE;
    document.head.appendChild(st);
  }
  var derniereCarte = null;
  document.addEventListener('click', function (e) {
    var carte = e.target.closest && e.target.closest('.moonbundle-box .moonbundle-upsell-item');
    if (carte) derniereCarte = carte;
  }, true);
  // le texte devient une liste à pastilles, un lien mène à la fiche, et un bouton coche le lubrifiant puis referme
  function fenetre() {
    if (!reglages()) return;
    document.querySelectorAll('.moonbundle-product-info-lightbox-panel').forEach(function (p) {
      if (p.__tm) return;
      p.__tm = true;
      var desc = p.querySelector('.moonbundle-product-info-lightbox-desc');
      if (desc && desc.textContent.trim()) {
        var ul = document.createElement('ul');
        ul.className = 'tm-mb-points';
        desc.textContent.split('\n').forEach(function (l) {
          l = l.trim();
          if (!l) return;
          var li = document.createElement('li');
          li.textContent = l;
          ul.appendChild(li);
        });
        desc.classList.add('tm-mb-cache');
        desc.parentNode.insertBefore(ul, desc.nextSibling);
      }
      var carte = derniereCarte;
      if (!carte) return;
      var lien = adresse(carte);
      if (lien) {
        var a = document.createElement('a');
        a.className = 'tm-mb-fiche';
        a.href = lien;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = 'Voir la fiche complète';
        (p.querySelector('.moonbundle-product-info-lightbox-scroll') || p).appendChild(a);
      }
      var coche = carte.querySelector('.moonbundle-upsell-checkbox input');
      var prix = carte.querySelector('.moonbundle-upsell-price');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tm-mb-choisir';
      if (epuise(carte)) {
        b.disabled = true;
        b.textContent = 'Épuisé pour le moment';
      } else {
        b.textContent = (coche && coche.checked ? R.choisi : R.choisir) + (prix ? ' · ' + prix.textContent.trim() : '');
      }
      b.addEventListener('click', function () {
        if (coche && !coche.checked) coche.click();
        var f = p.querySelector('.moonbundle-product-info-lightbox-close');
        if (f) f.click();
      });
      p.appendChild(b);
    });
  }
  var attente = 0;
  function plusTard() {
    if (attente) return;
    attente = requestAnimationFrame(function () { attente = 0; monter(); fenetre(); });
  }
  // un changement de coloris du sextoy relance le contrôle de disponibilité
  document.addEventListener('change', function () { setTimeout(plusTard, 300); });
  // l'offre pose ses réglages quand Moonbundle la dessine, parfois après ce script : elle relance
  window.__tmMbMonter = plusTard;
  monter();
  new MutationObserver(plusTard).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', plusTard);
})();
